import { lighten } from 'polished';

const siteStageLight = (theme) => lighten(0.0125, theme.site.stage.backgroundColor);
const siteStageLighter = (theme) => lighten(0.025, theme.site.stage.backgroundColor);
const siteStageLightest = (theme) => lighten(0.05, theme.site.stage.backgroundColor);

export default { siteStageLight, siteStageLighter, siteStageLightest };
